/**
 * Um ambiente numa lista da Capacidade: nome, pedido · cliente e a data que
 * importa naquela lista. O toque abre o painel lateral do ambiente quando a
 * linha da planilha foi encontrada pela chave PEDIDO:AMBIENTE.
 */
import React from "react";

import { CAMADA } from "../../utils/capacidade";
import { ROTULO_CAMADA, ddmm } from "./apresentacao";
import { SELO_VENDA_ASSINADA } from "./apresentacaoVendas";
import { LinhaItem, Selo } from "./styles";

export function rotuloPedidoCliente(item) {
  return [item.pedido, item.cliente].filter(Boolean).join(" · ") || "—";
}

function tituloDoBotao(item, abrivel) {
  if (abrivel) return "Abrir o painel do ambiente";
  if (item.camada === CAMADA.VENDA_ASSINADA) return "Venda assinada: ainda não está na planilha";
  return "Linha não encontrada na planilha atual";
}

export default function ItemAmbiente({ item, meta, mostrarCamada = false, podeAbrir, onAbrir }) {
  const abrivel = Boolean(podeAbrir?.(item));
  return (
    <LinhaItem>
      <button
        type="button"
        disabled={!abrivel}
        title={tituloDoBotao(item, abrivel)}
        onClick={() => onAbrir(item)}
      >
        <span className="nome">
          {item.ambiente || "—"}
          {item.camada === CAMADA.VENDA_ASSINADA ? (
            <Selo>{SELO_VENDA_ASSINADA}</Selo>
          ) : mostrarCamada && item.camada ? (
            <Selo>{ROTULO_CAMADA[item.camada]}</Selo>
          ) : null}
          {item.podeAtrasar ? <Selo $tom="warning">pode atrasar</Selo> : null}
        </span>
        <span className="meta">{meta ?? (item.entrega ? `entrega ${ddmm(item.entrega)}` : "sem entrega")}</span>
        <span className="sub">{rotuloPedidoCliente(item)}</span>
      </button>
    </LinhaItem>
  );
}
